import { Location } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import {
  GeneralSettingValue,
  GeneralSettingValueService,
  PageableResponse,
  SocietiesService,
  Society,
  StringUtils,
  UserService,
} from '@pwc-bei/common';
import { FilterValues } from '@pwc-bei/forms';
import { AuthenticationService } from '@pwc-bei/security';
import { debounceTime, switchMap } from 'rxjs/operators';
import { EAccessPlanVariable } from 'src/app/enum/access-plan-variable';

import { AuthenticationUtilsService } from 'src/app/services/authentication-utils.service';
import { SocietySelectionUtils } from 'src/app/utils/society-selection-utils';
import { faChevronLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { BasePage } from '../../base-page/base-page';
import { FaqThematicAreaEnum } from '../enum/faq-thematic-area.enum';
import { CallFaqResource } from '../models/api/callFaq-resource';
import { CallFaq } from '../models/callFaq';
import { CallFaqFilter } from '../models/callFaq-filter';
import { CallFaqService } from '../service/callFaq.service';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-faq-bandi',
    templateUrl: './callFaq-list.component.html',
    styleUrls: ['./callFaq-list.component.scss'],
    standalone: false
})
export class CallFaqListComponent
  extends BasePage
  implements OnInit, AfterViewInit {
  question: string;
  category: string;

  label;
  id;
  filters: CallFaqFilter;

  private emptyFilters: CallFaqFilter = {
    category: null,
    question: null
  }

  faChevronLeft = faChevronLeft;
  faCircleNotch = faCircleNotch;
  categoryNumber: number;
  callFaqs?: CallFaq[];
  callFaqsCategories: Array<string>;
  callFaqsQuestion: Set<string>;
  answerAccordion = true;
  helpDeskEmail: string;
  isCategorySelected: boolean = false;

  subtitle = '';
  subtitle2 = '';
  defaultSubtitle = 'rda.subtitle-1-v1'
  subtitleChange = 'rda.subtitle-1-v2';
  subtitleChange2 = 'rda.subtitle-2-v2';
  showFaq: boolean = false;
  isUserSmart: boolean = false;

  fromCOESection = false;

  initialized = false;
  emptyUIFilter: FilterValues = {
    category: null,
    answer: null,
    question: null,
  };

  UIFilter: FilterValues = { ...this.emptyUIFilter };
  logger: any;

  constructor(
    private router: Router,
    private callFaqService: CallFaqService,
    private changeDetector: ChangeDetectorRef,
    private societiesService: SocietiesService,
    private generalSettingValueService: GeneralSettingValueService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private authenticationUtilsService: AuthenticationUtilsService,
    private location: Location,
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {
    super();
  }

  get faAngleDown() {
    return faAngleDown;
  }

  get faAngleUp() {
    return faAngleUp;
  }

  toggleAccordion(item: CallFaq) {
    if (item.collapsed === null || item.collapsed === undefined) {
      item.collapsed = true;
      return;
    }

    item.collapsed = !item.collapsed;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subtitle = this.translateService.instant(this.defaultSubtitle)

    const selectedSociety = sessionStorage.getItem('society');

    if (environment.directChannel && this.currentlyInDeep(RoutePath.HOME, 0)) {
      this.fromCOESection = true
    }

    this.isUserSmart = this.authenticationUtilsService.getAccessPlan(EAccessPlanVariable.IS_USER_SMART);
    this.isUserSmart && !this.fromCOESection ? this.router.navigate([RoutePath.BANDI, RoutePath.TAX_BREAK]) : this.showFaq = true;
    console.log("FAQ -------->", selectedSociety);
    if (selectedSociety === null || selectedSociety === undefined) {
      this.societiesService.currentSociety$.subscribe((society) => {
        if (society == null) {
          this.userService
            .getSocietiesForGroupCodes(SocietySelectionUtils.GROUP_CODES)
            .subscribe((societies: Society[]) => {
              if (societies.length > 1) {
                this.router.navigate([
                  RoutePath.BANDI,
                  RoutePath.TAX_BREAK,
                  RoutePath.SOCIETY_SELECTION,
                ]);
              } else {
                if (societies.length > 0) {
                  this.societiesService.setSociety(
                    societies[societies.length - 1],
                  );
                }
              }
            });
        }
      });
    } else {
      this.societiesService.setSociety(JSON.parse(selectedSociety));
    }

    this.subscriptions.push(
      this.callFaqService.pagination$.subscribe(
        (pagination: PageableResponse<CallFaqResource[]>) => {
          this.pagination = { ...pagination };
        },
      ),
    );

    this.initHelpDeskEmail();
    this.initSearch();
    this.onSearch();

    this.filters = {
      ...this.emptyFilters,
    };
  }

  ngAfterViewInit(): void {
    this.initialized = true;
    this.changeDetector.detectChanges();
    window.scrollTo(0, 0);
  }

  private initSearch(): void {
    console.log('init search');

    this.subscriptions.push(
      this.searchTrigger$
        .pipe(
          debounceTime(300),
          switchMap(() => this.societiesService.getSelectedSociety()),
          switchMap((society: Society) => {
            const search: Partial<CallFaq> = this.getFilters(this.filters);
            // const filterFromModule =
            //   this.route.snapshot.fragment != null &&
            //     ![
            //       FaqThematicAreaEnum.RDP,
            //       FaqThematicAreaEnum.BANDI,
            //       FaqThematicAreaEnum.CHANGE_PASSWORD,
            //       FaqThematicAreaEnum.PROFILE,
            //     ].includes(this.route.snapshot.fragment.toUpperCase() as FaqThematicAreaEnum)
            //     ? this.route.snapshot.fragment
            //     : FaqThematicAreaEnum.BANDI_INCENTIVI;

            const filterFromModule =
              this.route.snapshot.fragment != null && this.route.snapshot.fragment === RoutePath.LIVE_ASSISTANT
              ? this.route.snapshot.fragment
              : FaqThematicAreaEnum.BANDI_INCENTIVI;
            search.page = this.currentPage;
            search.size = this.pageSize;
            search.filterFromModule = filterFromModule;
            search.filterSociety = society.id;

            return this.callFaqService.searchPost(search);
          }),
        )
        .subscribe((data: CallFaq[]) => {
          this.callFaqs = [...data];
          this.currentPage = 0;
        }),
    );

    this.callFaqService.getCategories().subscribe((data: Array<string>) => {
      this.callFaqsCategories = [...data];
    });
  }

  categoryIsSelected() {
    this.subtitle = this.translateService.instant(this.subtitleChange);
    this.subtitle2 = this.translateService.instant(this.subtitleChange2);
  }

  private initHelpDeskEmail(): void {
    this.societiesService
      .getSelectedSociety()
      .pipe(
        switchMap((society: Society) =>
          this.generalSettingValueService.findByCode(
            'HELPDESK_EMAIL',
            society?.id,
          ),
        ),
      )
      .subscribe((list: GeneralSettingValue[]) => {
        if (list == null || list.length === 0) {
          this.helpDeskEmail = environment.helpDeskEmail;
          return;
        }

        const setting = list[0];
        this.helpDeskEmail = setting.value;
      });
  }

  goToHomepage() {
    // this.authenticationService.cookie
    //     .subscribe((cookie: AuthenticationCookie) => {
    //         window.location.href = RoutePath.TAX_BREAK;
    //     });
    this.router.navigate([
      RoutePath.HOME
    ]);
  }

  private getFilters($event) {
    if ($event === null || $event === undefined) {
      return {};
    }
    const filters = $event;
    const search: Partial<CallFaq> = {};

    if (!StringUtils.isEmpty(filters.question)) {
      search.question = filters.question;
    }

    if (!StringUtils.isEmpty(filters.category)) {
      search.category = filters.category;
    }

    return search;
  }

  currentlyInDeep(pathName: string, deep: number) {
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[deep];
    return currentPath === pathName;
  }

}
